import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ViewDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  data: Record<string, any>;
}

const ViewDialog: React.FC<ViewDialogProps> = ({
  open,
  onClose,
  title,
  data,
}) => {

  const excludedFields = ['originalData','photoId']; // Add any field names you want to hide here
  
  // Filter out excluded fields
  const filteredData = Object.entries(data).filter(([key]) => !excludedFields.includes(key));

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: '#1e1e1e',
          color: '#ffffff',
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: '#ffffff',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ backgroundColor: '#1e1e1e', borderColor: 'rgba(255, 255, 255, 0.12)' }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          {filteredData.map(([key, value]) => (
            <Box key={key} sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              backgroundColor: '#252526',
              borderRadius: 1,
              p: 1.5
            }}>
              <Typography variant="caption" sx={{ color: '#888', mb: 0.5, textTransform: 'capitalize' }}>
                {key.replace(/([A-Z])/g, ' $1').trim()}
              </Typography>
              <Typography variant="body2">
                {value?.toString() || '-'}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#1e1e1e', borderTop: '1px solid rgba(255, 255, 255, 0.12)' }}>
        <Button 
          onClick={onClose} 
          sx={{ 
            color: '#ffffff',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDialog;
